import type { ZodSchema } from "zod";

type FieldErrors = Record<string, string[] | undefined>;

export function validateFormData<T>(schema: ZodSchema<T>, formData: FormData) {
  const raw = Object.fromEntries(formData) as Record<string, unknown>;
  const result = schema.safeParse(raw);
  if (result.success) return { data: result.data, errors: null };
  return { data: null, errors: result.error.flatten().fieldErrors as FieldErrors };
}

export function validateFields<T>(schema: ZodSchema<T>, data: unknown) {
  const result = schema.safeParse(data);
  if (result.success) return { data: result.data, errors: null };
  return { data: null, errors: result.error.flatten().fieldErrors as FieldErrors };
}
